import { PaletteMode } from "@mui/material";
import { useColorScheme } from "@mui/material/styles";
import { syncIntercomThemeMode } from "@themes/intercomTheme";
import { useCallback } from "react";

export type ThemeMode = PaletteMode;

export const useThemeMode = () => {
  const { mode, setMode } = useColorScheme();

  const resolvedMode: ThemeMode = mode === "dark" ? "dark" : "light";

  const setThemeMode = useCallback(
    (nextMode: ThemeMode) => {
      // Guard: skip if already in the requested mode to avoid unnecessary
      // localStorage writes and Intercom updates.
      if (nextMode === resolvedMode) return;
      syncIntercomThemeMode(nextMode);
      setMode(nextMode);
    },
    [setMode, resolvedMode]
  );

  const toggleThemeMode = useCallback(() => {
    const nextMode: ThemeMode = resolvedMode === "light" ? "dark" : "light";
    syncIntercomThemeMode(nextMode);
    setMode(nextMode);
  }, [resolvedMode, setMode]);

  return {
    mode: resolvedMode,
    setMode: setThemeMode,
    toggleMode: toggleThemeMode
  };
};

export default useThemeMode;
